import { FaFacebookF, FaInstagram, FaTwitter } from "react-icons/fa";

export const footerSocialLinks = [
  { id: 1, Icon: FaFacebookF, link: "https://www.facebook.com/" },
  { id: 2, Icon: FaTwitter, link: "https://www.twitter.com/" },
  { id: 3, Icon: FaInstagram, link: "https://www.instagram.com/" },
];
